import React, { createContext, useState, useContext, useEffect } from 'react';

const UserPreferencesContext = createContext();

export const useUserPreferences = () => useContext(UserPreferencesContext);

export const UserPreferencesProvider = ({ children, useLocalStorage = false }) =>
{
	const [siteFilter, setSiteFilter] = useState('all');
	const [siteOrder, setSiteOrder] = useState('default');

	// Placeholder for future localStorage integration
	const savePreferences = (preferences) =>
	{
		if (useLocalStorage)
		{
			localStorage.setItem('userPreferences', JSON.stringify(preferences));
		}
	};

	// Update preferences and save them (to state for now, to localStorage later)
	const updatePreferences = (preferences) =>
	{
		const { siteFilter, siteOrder } = preferences;
		setSiteFilter(siteFilter);
		setSiteOrder(siteOrder);
		savePreferences(preferences);
	};

	// Load preferences from localStorage (future implementation)
	useEffect(() =>
	{
		if (useLocalStorage)
		{
			const storedPreferences = localStorage.getItem('userPreferences');
			if (storedPreferences)
			{
				const preferences = JSON.parse(storedPreferences);
				updatePreferences(preferences);
			}
		}
	},
  	[]);

	return (
		<UserPreferencesContext.Provider value={{
			siteFilter,
			siteOrder,
			updatePreferences
		}}>
			{children}
		</UserPreferencesContext.Provider>
	);
};
